module.exports = __webpack_public_path__ + "img/type_word.6f4881e2.svg";